import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let DeviceDom = class DeviceDom extends Vue {
    // highlight:string = highlight;
    status = '';
    deviceId = '';
    handleClick(e) {
        // e.preventDefault();
        e.stopPropagation();
        // this.dialogVisible = true;
        this.$emit('onClickDevice', this.deviceId);
    }
};
DeviceDom = __decorate([
    Component({
        name: 'device',
    })
], DeviceDom);
export default DeviceDom;
;
